import React, {Component} from 'react';
import HttpClient from 'services/HttpClient';
import {Link} from 'react-router-dom';
import logo_2 from '../styles/img/organizations/logo_2.png';
import logo_2x from '../styles/img/organizations/logo_2@2x.png';
import logo_3x from '../styles/img/organizations/logo_2@3x.png';
import partner1 from '../styles/img/organizations/partner_01.jpg';
import partner1_2x from '../styles/img/organizations/partner_01@2x.jpg';
import partner1_3x from '../styles/img/organizations/partner_01@3x.jpg';
import partner2 from '../styles/img/organizations/partner_02.jpg';
import partner2_2x from '../styles/img/organizations/partner_02@2x.jpg';
import partner2_3x from '../styles/img/organizations/partner_02@3x.jpg';
import partner3 from '../styles/img/organizations/partner_03.jpg';
import partner3_2x from '../styles/img/organizations/partner_03@2x.jpg';
import partner3_3x from '../styles/img/organizations/partner_03@3x.jpg';
import partner4 from '../styles/img/organizations/partner_04.jpg';
import partner4_2x from '../styles/img/organizations/partner_04@2x.jpg';
import partner4_3x from '../styles/img/organizations/partner_04@3x.jpg';
import partner5 from '../styles/img/organizations/partner_05.jpg';
import partner5_2x from '../styles/img/organizations/partner_05@2x.jpg';
import partner5_3x from '../styles/img/organizations/partner_05@3x.jpg';

const INDEX_ORGANIZATION_WORKSHOPS = '/api/v1/workshops/online/?&workshop_types[]=4&page=1';

class OrganizationsInfo extends Component {
  state = {organization_workshops: []} ;

  componentWillMount = () => {
    new HttpClient().get(INDEX_ORGANIZATION_WORKSHOPS).then(data => {
      const onlyThree = data.body.data.workshops.slice(0, 3);
      this.setState({organization_workshops: onlyThree});
    });
  };

  goToAll = () => {
    this.props.history.replace('/online_workshops', {organizations: true});
  }

  render() {
    const {organization_workshops} = this.state;
    return (
      <div className="content__wrapper">
        <section className="hero sections">
          <div className="hero__content">
            <div className="hero__block">
              <div className="hero__logo">
                <img src={logo_2} srcSet={`${logo_2x} 2x, ${logo_3x} 3x`} alt="TherapyAcademy" />
              </div>
              <div className="hero__text">
                <p>
                  Therapy Academy organisation training courses are delivered online and can be tailored to your organisation's specific needs.
                </p>
                <br />
                <p>Call <a href="call:0873356536">087 3356536</a> or email us at <a href="mailto:support@therapyacademy.ie">support@therapyacademy.ie</a></p>
                {/* <span className="add-workshop nav-btn btn prime bordered" onClick={this.goToAll} style={{marginTop: '42px'}}>View Organisation Workshops</span> */}
                <br />
                <p>Does your organisation facilitate CPD training for staff and volunteers? At Therapy Academy we can provide free access to our online workshops and webinars and bill your organisation directly. We can arrange for individual or group training on all manner of topics. Please email <a href='mailto:support@therapyacademy.ie'>support@therapyacademy.ie</a> for more information.</p>
              </div>
            </div>
          </div>
        </section>
        <section className="patrners sections">
          <div className="partners__content">
            <div className="partners__text">
              <p>
                We have partnered with workshop and webinar course providers from the following accreditation bodies
              </p>
            </div>
            <div className="partners__list">
              <ul className="list">
                <li className="list__item">
                  <a className="list__link image__link" target="_blank" href="#">
                    <img src={partner1} srcSet={`${partner1_2x} 2x, ${partner1_3x} 3x`} alt="Partner 1" />
                  </a>
                </li>
                <li className="list__item">
                  <a className="list__link image__link" target="_blank" href="#">
                    <img src={partner2} srcSet={`${partner2_2x} 2x, ${partner2_3x} 3x`} alt="Partner 2" />
                  </a>
                </li>
                <li className="list__item">
                  <a className="list__link image__link" target="_blank" href="#">
                    <img src={partner3} srcSet={`${partner3_2x} 2x, ${partner3_3x} 3x`} alt="Partner 3" />
                  </a>
                </li>
                <li className="list__item">
                  <a className="list__link image__link" target="_blank" href="#">
                    <img src={partner4} srcSet={`${partner4_2x} 2x, ${partner4_3x} 3x`} alt="Partner 4" />
                  </a>
                </li>
                <li className="list__item">
                  <a className="list__link image__link" target="_blank" href="#">
                    <img src={partner5} srcSet={`${partner5_2x} 2x, ${partner5_3x} 3x`} alt="Partner 5" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="sectors sections">
          <div className="sectors__content">
            <div className="sectors__block">
              <h2 className="section__title section__title--blue">Sectors and Professions</h2>
              <div className="section__description">
                Our experienced course providers can facilitate training over a broad range of topics. We have previously worked with organisations and practitioners in the following sectors and professions: 
              </div>
              <div className="sectors__text">
                <ul>
                  <li>Charities</li>
                  <li>Community Groups</li>
                  <li>Education</li>
                  <li>Government</li>
                  <li>Health Organisations </li>
                  <li>Mental Health Organisations </li>
                </ul>
                <ul>
                  <li>Therapists</li>
                  <li>Teachers & SNAs</li>
                  <li>Nurses</li>
                  <li>Social Workers</li>
                  <li>Volunteers</li>
                  <li className="sectors__text_list_without_point">… аnd more</li>
                </ul>
              </div>						
            </div>
          </div>
        </section>
        <section className="samples sections">
          <div className="samples__content">
            {/* New ----- */}
            {/* <h2 className="section__title section__title--big">Sample Workshops</h2> */}
            {/* End new ------ */}
            <h2 className="section__title section__title--big">Easy access staff training</h2>
            <div className="samples__list">
              <p>Does your organisation facilitate CPD training for staff and volunteers? At Therapy Academy we can provide free access to our online workshops and webinars and bill your organisation directly. We can arrange for individual or group training on all manner of topics. Please email <a href='mailto:support@therapyacademy.ie'>support@therapyacademy.ie</a> for more information.</p>
              {/* New -------- */}
              {/* {organization_workshops.map(item => (
                <div key={item.id} className="list__item">
                  <div className="samples__card">
                    <div className="card__block">
                      <div className="workshop__author">
                        {item.provider_logo_url ?
                          <figure className="author__avatar">
                            <img src={item.provider_logo_url} alt={item.provided_by} />
                          </figure> :
                          <div className="author__avatar" />
                        }
                        <div className="card__right">
                          <div className="author__name">{item.provided_by}</div>
                          <div className="author__post">{item.summary}</div>
                        </div>
                      </div>
                      <div className="workshop__title">
                        <Link to={`/provider/org/${item.id}`}>{item.title}</Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))} */}
              {/* End New ------- */}

              {/* OLD ------ */}
              {/* <div className="list__item">
                <div className="samples__card">
                  <div className="card__block">
                    <div className="workshop__author">
                      <figure className="author__avatar">
                        <img src="img/avatar.jpg" srcset="img/avatar@2x.jpg 2x, img/avatar@3x.jpg 3x" alt="" />
                      </figure>
                      <div className="card__right">
                        <div className="author__name">Chrissie Tizzard</div>
                        <div className="author__post">Psychotherapist & Supervisor</div>
                      </div>
                    </div>
                    <div className="workshop__title">
                      <a href="#">Reducing PTSD in Frontline Staff During Covid19</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="list__item">
                <div className="samples__card">
                  <div className="card__block">
                    <div className="workshop__author">
                      <figure className="author__avatar">
                        <img src="img/avatar.jpg" srcset="img/avatar@2x.jpg 2x, img/avatar@3x.jpg 3x" alt="" />
                      </figure>
                      <div className="card__right">
                        <div className="author__name">Chrissie Tizzard</div>
                        <div className="author__post">Trauma: A new Paradigm</div>
                      </div>
                    </div>
                    <div className="workshop__title">
                      <a href="#">Cannabis, Cocaine & Heroin Addiction Awareness Series</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="list__item">
                <div className="samples__card">
                  <div className="card__block">
                    <div className="workshop__author">
                      <figure className="author__avatar">
                        <img src="img/avatar.jpg" srcset="img/avatar@2x.jpg 2x, img/avatar@3x.jpg 3x" alt="" />
                      </figure>
                      <div className="card__right">
                        <div className="author__name">Chrissie Tizzard</div>
                        <div className="author__post">Chartered Psychologist </div>
                      </div>
                    </div>
                    <div className="workshop__title">
                      <a href="#">Trauma: A new Paradigm</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="list__item">
                <div className="samples__card">
                  <div className="card__block">
                    <div className="workshop__author">
                      <figure className="author__avatar">
                        <img src="img/avatar.jpg" srcset="img/avatar@2x.jpg 2x, img/avatar@3x.jpg 3x" alt="" />
                      </figure>
                      <div className="card__right">
                        <div className="author__name">Chrissie Tizzard</div>
                        <div className="author__post">Trauma: A new Paradigm</div>
                      </div>
                    </div>
                    <div className="workshop__title">
                      <a href="#">Introduction to Understanding Postnatal Depression</a>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* End OLD ------ */}
            </div>
            {/* New ---- */}
            {/* <span className="add-workshop nav-btn btn prime bordered" onClick={this.goToAll} style={{marginTop: '42px'}}>MORE ORGANISATION WORKSHOPS</span> */}
            {/* End new ------ */}
          </div>
        </section>
        <section className="bespoke sections">
          <div className="bespoke__content">
            <h2 className="section__title section__title--blue">Bespoke Workshops</h2>
            <div className="section__description">
              We can arrange online workshops or live webinars based on your needs
            </div>
            <div className="bespoke__text">
              <div className="bespoke__column">
                <p>
                  Bespoke Workshops
                </p>
                <ul>
                  <li>Individual or Group</li>
                  <li>Learning style - Live engagement or self directed. </li>
                  <li>Workshop content - Academic, practical, experiential or evidence based </li>
                  <li>Expert providers - Experienced professionals from a range of fields</li>
                  <li>Length - Arranged to suit organisations</li>
                  <li>Cost - To fit all budgets</li>
                </ul>
              </div>
              <div className="bespoke__column">
                <p>
                  Organisation Benefits
                </p>
                <ul>
                  <li>Simple and flexible participation</li>
                  <li>User support</li>
                  <li>User engagement records</li>
                  <li>Automatic CPD cert / attendance cert generation</li>
                  <li>Access to high quality professionals</li>
                  <li>Bespoke workshop options</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="contactus sections">
          <div className="contactus__content">
            <h2 className="section__title section__title--big">Contact us</h2>
            <p>
              For more details, please email us at <a href="mailto:support@therapyacademy.ie">support@therapyacademy.ie</a> or call <a href="call:0873356536">087 3356536</a>
            </p>
          </div>
        </section>
      </div>
    );
  }
}

export default OrganizationsInfo;


// WEBPACK FOOTER //
// ./src/components/OrganizationsInfo.jsx